import React, { useEffect } from "react";

const SHGAddMemberModal = ({ isOpen, onClose, newMember, setNewMember, editingMember, onSubmit, message, submitting }) => {

  useEffect(() => {
    if (isOpen && editingMember) {
      setNewMember(editingMember);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, editingMember?._id]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-[100] px-4 py-6 overflow-y-auto">
      <div className="bg-gray-900 border border-pink-500/50 rounded-3xl w-full max-w-lg my-auto max-h-[90vh] overflow-y-auto">
        <div className="p-8">
          <h3 className="text-xl lg:text-2xl font-bold text-pink-100 mb-8">
            {editingMember ? "Edit Member ✨" : "Add New Member 💕"}
          </h3>

          <div className="space-y-2">
            <div>
              <label className="block text-pink-300 text-sm mb-2">Full Name <span className="text-red-400">*</span></label>
              <input type="text" value={newMember.userName} onChange={(e) => setNewMember({...newMember, userName: e.target.value})} className="w-full bg-gray-800 border border-pink-700 focus:border-pink-400 rounded-2xl px-5 py-4 outline-none" placeholder="Priya Sharma" />
            </div>

            <div className="grid grid-cols-2 gap-6">
              <div>
                <label className="block text-pink-300 text-sm mb-2">User Code <span className="text-red-400">*</span></label>
                <input type="text" value={newMember.userCode} onChange={(e) => setNewMember({...newMember, userCode: e.target.value})} className="w-full bg-gray-800 border border-pink-700 focus:border-pink-400 rounded-2xl px-5 py-4 outline-none" placeholder="FH003" />
              </div>
              <div>
                <label className="block text-pink-300 text-sm mb-2">Contribution (₹)</label>
                <input type="number" value={newMember.contributionAmount} onChange={(e) => setNewMember({...newMember, contributionAmount: Number(e.target.value)})} className="w-full bg-gray-800 border border-pink-700 focus:border-pink-400 rounded-2xl px-5 py-4 outline-none" />
              </div>
            </div>

            <div>
              <label className="block text-pink-300 text-sm mb-2">Key Responsibility Area (KRA)</label>
              <input type="text" value={newMember.memberKRA} onChange={(e) => setNewMember({...newMember, memberKRA: e.target.value})} className="w-full bg-gray-800 border border-pink-700 focus:border-pink-400 rounded-2xl px-5 py-4 outline-none" placeholder="Content Creator / Treasurer" />
            </div>
          </div>

          {message && (
            <div className="text-amber-400 text-sm mt-6 px-1">{message}</div>
          )}

          <div className="flex gap-4 mt-4">
            <button onClick={onClose} disabled={submitting} className="flex-1 w-fit px-2 py-1 border border-gray-600 hover:bg-gray-800 rounded-2xl font-medium disabled:opacity-50">Cancel</button>
            <button 
                onClick={onSubmit} 
                disabled={submitting || !newMember.userName || !newMember.userCode}
                className="flex-1 w-fit px-2 py-1 bg-pink-600 hover:bg-pink-500 rounded-2xl font-semibold disabled:opacity-50"
            >
              {submitting ? "Saving..." : (editingMember ? "Save Changes ✨" : "Add Member")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SHGAddMemberModal;